export default __webpack_public_path__ + "static/media/back-all-files.11420ae9.svg";